import { getLanguages } from "../services";
import { assignmentDecision, getAssignedValue, deflateModelVariables } from '../util';


export const getConfiguration = ( product, user ) => {
  //Making configuration as a list for genearting supercode sepeartely for fixed and moving part
  let configurations = [];
  let additonalProductAccessoriesAssignments;
  let fixedPartConfiguration;
  const accessoriesAssignments = getAccessoryAssignment( getAccessories( product ) );
  //Moving part configuration
  if( accessoriesAssignments.length ){
    const mainPartConfiguration = {
        configuration:{
            variantId: product.name, 
            productDescription:product.description,
            accessoriesAssignments, 
            bom: getBomItems( accessoriesAssignments ),
            userName: user.name,
            userCountry:user.country,
            channel :user.authenticationType
          },
          customerExternalId: user.properties['CustomerCode'],
          salesOrganization: user.properties['SalesOrganization']
        };
    configurations.push( mainPartConfiguration );
  }
  //Fixed part configuration. product.additionalProducts contains the Fixed part
  if( product.additionalProducts && product.additionalProducts.length > 0 ){
    additonalProductAccessoriesAssignments = getAccessoryAssignment( getAccessories( product.additionalProducts[0] ) );
    if( additonalProductAccessoriesAssignments.length ){
      fixedPartConfiguration = {
        configuration:{
            variantId: product.additionalProducts[0].name, 
            productDescription:product.description,
            accessoriesAssignments: additonalProductAccessoriesAssignments, 
            bom: getBomItems( additonalProductAccessoriesAssignments ),
            userName: user.name,
            userCountry:user.country,
            channel :user.authenticationType
          },
          customerExternalId: user.properties['CustomerCode'],
          salesOrganization: user.properties['SalesOrganization']
        };
      configurations.push( fixedPartConfiguration );
    }
  }
  //List of configurations
  return configurations;
} 

export const getConfigurationObject = ( accessory, product,additionalAssignments=[],
  additionalVariantId='',variantKMAT='',accessoriesKMAT='',selectorAssignments=[],additionalKMAT='') => {
  return { variantId: product, accessoriesAssignments: accessory, bom: getBomItems( accessory ),additionalAccessoryAssignment:additionalAssignments,additionalBOM:getBomItems(additionalAssignments)
  ,additionalVariantId:additionalVariantId, variantKMAT:variantKMAT,accessoriesKMAT:accessoriesKMAT,selectorAssignments:selectorAssignments,
   additionalAccessoryKMAT:additionalKMAT ,additionalVariantIdKMAT:additionalKMAT};
} 

const getAccessories = ( product ) => {
  const configuration = product.configuration;
  if( !configuration ) {
    return [];
  }

  const lang = getLanguages().first();
  const accessories = configuration && deflateModelVariables( configuration.model );
  const filteredAccessories = accessories.filter( accessory => 
    assignmentDecision( configuration.productModelType, lang )( accessory ) && getAssignedValue( accessory ) !== configuration.product.name 
  );

  return filteredAccessories;
}

export const getAccessoryAssignment = ( accessories ) => {
  return accessories.map(acc => {
    return { variableName: acc.name, valueName: acc.assignedValue.name, valueDesc:acc.assignedValue.title}
  });
}

export const getBomItems = ( accessoryAssignments ) => {
  return accessoryAssignments.map( accessory => accessory.valueName );
}

export const getSaveToSapRequestObject = ( response, user ) => {
  return { 
    configuration: { 
      accessoriesAssignments: response.accessoriesAssignments, 
      bom: getBomItems( response.accessoriesAssignments ), 
      variantId: response.variantId,
      configurationId: response.superCode,
      userName: user.name,
      userCountry:user.country,
      channel :user.authenticationType
    } ,
    customerExternalId: user.properties['CustomerCode'],
    salesOrganization: user.properties['SalesOrganization'] 
  }
}